var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFromTemplate = function SvgFromTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.058 17.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T8.058 2.5h11.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V6h-12v9.692q0 .116.096.212a.3.3 0 0 0 .212.096m-3.5 5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308h1.5v12.884q0 .116.096.212a.3.3 0 0 0 .212.096h12.884V21z"
  })));
};
export default SvgFromTemplate;